<template>
    <div class="c-title">
        <div v-if="tags.length" class="c-title-tags">
            <span v-for="(tag, index) in tags" :key="index" class="c-title-tag">{{ tag }}</span>
        </div>
        <h1 class="c-title-h1 ellipsis" :title="name">
            {{ name }}
        </h1>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        tags: {
            type: Array,
            default: () => {
                return [];
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.c-title {
    text-align: left;
    &-tags {
        margin-bottom: 12px;
        color: #ffffff;
        background-color: #babdc0;
        display: inline-block;
        padding: 4px 12px;
        border-radius: 4px;
    }
    &-tag {
        font-size: 14px;
        & + & {
            margin-left: 8px;
        }
    }
    &-h1 {
        margin: 0;
        font-size: 20px;
        color: #322d33;
    }
}
</style>
